import React, { useMemo, useState } from 'react';

const AttendanceView = ({ staff = [], attendance = [], onRecordAttendance }) => {
    const [staffId, setStaffId] = useState('');
    const [method, setMethod] = useState('badge');
    const [reference, setReference] = useState('');

    const selectedStaff = staff.find(member => String(member.id) === String(staffId));
    const openSessions = useMemo(() => attendance.filter(entry => entry.type === 'check-in' && !attendance.some(exit => exit.type === 'check-out' && exit.sessionId === entry.id)), [attendance]);

    const submit = (event) => {
        event.preventDefault();
        if (!staffId || !reference.trim()) {
            alert('Sélectionnez un employé et saisissez la référence du badge ou de l’appareil.');
            return;
        }
        const activeSession = openSessions.find(entry => String(entry.staffId) === String(staffId));
        onRecordAttendance({
            id: `${method}-${Date.now()}`,
            sessionId: activeSession?.id || null,
            staffId,
            staffName: selectedStaff?.name || 'Employé',
            type: activeSession ? 'check-out' : 'check-in',
            method,
            reference: reference.trim(),
            date: new Date().toISOString()
        });
        setReference('');
    };

    return (
        <div style={{ padding: '24px', maxWidth: '960px', margin: '0 auto' }}>
            <h2>Présence des employés</h2>
            <p>Enregistrez l’arrivée et la sortie avec un badge, un appareil ou une référence validée.</p>
            <p style={{ color: '#475569' }}>Aucune empreinte biométrique brute n’est conservée dans l’application.</p>
            <section style={{ padding: '20px', border: '1px solid #dbeafe', borderRadius: '12px', backgroundColor: '#f8fbff' }}>
                <form onSubmit={submit} style={{ display: 'grid', gap: '12px' }}>
                    <label>Employé<select value={staffId} onChange={(event) => setStaffId(event.target.value)} style={{ display: 'block', width: '100%', padding: '10px', marginTop: '6px' }}><option value="">Sélectionner</option>{staff.map(member => <option key={member.id} value={member.id}>{member.name} · {member.role}</option>)}</select></label>
                    <label>Type d’appareil<select value={method} onChange={(event) => setMethod(event.target.value)} style={{ display: 'block', width: '100%', padding: '10px', marginTop: '6px' }}><option value="badge">Badge / carte</option><option value="fingerprint">Appareil d’empreinte</option><option value="bluetooth">Bluetooth</option><option value="usb">USB</option></select></label>
                    <label>Référence de validation<input value={reference} onChange={(event) => setReference(event.target.value)} placeholder="Référence fournie par l’appareil" style={{ display: 'block', width: '100%', padding: '10px', marginTop: '6px' }} /></label>
                    <button type="submit" style={{ width: 'fit-content', padding: '12px 18px', border: 0, borderRadius: '8px', backgroundColor: '#0d3b66', color: '#fff' }}>{openSessions.some(entry => String(entry.staffId) === String(staffId)) ? 'Enregistrer la sortie' : 'Enregistrer l’arrivée'}</button>
                </form>
            </section>
            <section style={{ marginTop: '20px' }}>
                <h3>Journal de présence</h3>
                {attendance.length ? <ul>{attendance.slice().reverse().map(entry => <li key={entry.id}>{new Date(entry.date).toLocaleString()} · {entry.staffName} · {entry.type === 'check-in' ? 'Arrivée' : 'Sortie'} · {entry.method}</li>)}</ul> : <p>Aucune présence enregistrée.</p>}
            </section>
        </div>
    );
};

export default AttendanceView;
